module.exports = __webpack_public_path__ + "static/media/lamis.38bc82b8.jpg";